import { render, staticRenderFns } from "./OkCancelDialogFromAction.vue?vue&type=template&id=4b217880&scoped=true&"
import script from "./OkCancelDialogFromAction.vue?vue&type=script&lang=js&"
export * from "./OkCancelDialogFromAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b217880",
  null
  
)

export default component.exports